export async function fileFromMediaUrl(url, filename = "image.jpg") {
  if (!url) {
    throw new Error("Немає зображення для редагування.");
  }
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error("Не вдалося завантажити зображення для редагування.");
  }
  const blob = await response.blob();
  const type = blob.type || "image/jpeg";
  return new File([blob], filename, { type });
}
